import React from "react";

export default function PollView({ poll, onVote, accent = "#007c84" }) {
  if (!poll) return null;
  const total = poll.total_votes || 0;

  return (
    <div style={{ minWidth: 220, maxWidth: 280 }}>
      <div style={{ fontWeight: 700, fontSize: "0.92rem", color: "#222", marginBottom: 8, display: "flex", alignItems: "center", gap: 6 }}>
        📊 {poll.question}
      </div>
      <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
        {poll.options.map(opt => {
          const pct = total > 0 ? Math.round((opt.votes / total) * 100) : 0;
          return (
            <button
              key={opt.id}
              onClick={() => onVote(poll.id, opt.id)}
              style={{
                position: "relative", textAlign: "left", border: opt.mine ? `1.5px solid ${accent}` : "1px solid #e0e3ee",
                borderRadius: 8, padding: "7px 10px", background: "#fff", cursor: "pointer", overflow: "hidden",
              }}
            >
              <div style={{
                position: "absolute", top: 0, left: 0, bottom: 0, width: `${pct}%`,
                background: opt.mine ? `${accent}22` : "#f0f2f8", transition: "width 0.3s",
              }} />
              <div style={{ position: "relative", display: "flex", justifyContent: "space-between", gap: 8, fontSize: "0.86rem", color: "#222" }}>
                <span>{opt.mine ? "✓ " : ""}{opt.text}</span>
                <span style={{ color: "#888", flexShrink: 0 }}>{pct}%</span>
              </div>
            </button>
          );
        })}
      </div>
      <div style={{ fontSize: "0.74rem", color: "#999", marginTop: 6 }}>
        {total === 0 ? "Пока нет голосов" : `Голосов: ${total}`}
      </div>
    </div>
  );
}
